import { Component } from '@angular/core';

@Component({
    selector: 'bug-report-dialog',
    templateUrl: './bug-report-dialog.component.html',
})
export class BugReportDialogComponent {}
